// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BreadCrumbs {
  display: flex;
}
.BreadCrumbs-customBreadCrumb {
  cursor: default;
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/components/BreadCrumbs/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AACE;EACE,eAAA;EACA,oBAAA;AACJ","sourcesContent":[".BreadCrumbs {\n  display: flex;\n\n  &-customBreadCrumb {\n    cursor: default;\n    pointer-events: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
